<template>
  <div class="columns">
    <overview-menu v-if="window.width >= 780" @viewChanged="view = $event"></overview-menu>
    <buildings-project v-if="view === 'buildings'"></buildings-project>
    <users-project v-if="view === 'users'"></users-project>
    <info-project v-if="view === 'info'"></info-project>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import { mapGetters, mapActions } from 'vuex'
import OverviewMenu from '@/components/Projects/OverviewMenu'
import BuildingsProject from '@/components/Projects/BuildingsProject'
import UsersProject from '@/components/Projects/UsersProject'
import InfoProject from '@/components/Projects/InfoProject'

export default {
  components: {
    Breadcrumbs,
    OverviewMenu,
    BuildingsProject,
    UsersProject,
    InfoProject
  },

  data() {
    return {
      view: 'buildings',
      window: { width: 0, height: 0 }
    }
  },
  computed: {
    ...mapGetters(['project'])
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      console.log('changed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/ProjectOverview.vue